export default __webpack_public_path__ + "static/media/open-positions-pop-up-4k.59c5488c.jpg";